var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessSignUpImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 180,
    viewBox: "0 0 234 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.925 59.3455C220.783 36.7362 197.268 13.2173 174.654 7.07484C160.788 3.61969 142.214 0.0594141 117 0C91.7856 0.0594141 73.2118 3.61969 59.3455 7.07484C36.7362 13.2173 13.2173 36.7316 7.07484 59.3455C3.61969 73.2118 0.0594141 91.7856 0 117C0.0594141 142.214 3.61969 160.788 7.07484 174.654C13.2173 197.268 36.7362 220.783 59.3455 226.925C73.2118 230.38 91.7947 233.941 117 234C142.21 233.941 160.788 230.38 174.654 226.925C197.268 220.783 220.783 197.268 226.925 174.654C230.38 160.788 233.941 142.205 234 117C233.941 91.7856 230.38 73.2118 226.925 59.3455Z",
    fill: "#E8F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.972 101.589C184.752 98.4566 181.524 95.3137 178.288 92.1602C178.196 87.7818 178.082 83.4004 177.945 79.016C177.762 73.1523 175.23 67.5582 170.879 63.2073C166.689 58.93 161.026 56.4099 155.043 56.1599C150.65 56.0227 146.259 55.9085 141.872 55.8171C138.697 52.5996 135.554 49.3806 132.443 46.16C130.469 44.0388 128.079 42.3471 125.423 41.1903C122.766 40.0335 119.9 39.4365 117.002 39.4365C114.105 39.4365 111.238 40.0335 108.582 41.1903C105.925 42.3471 103.535 44.0388 101.561 46.16C98.4476 49.3836 95.2986 52.6102 92.1147 55.8399C87.7271 55.9252 83.3396 56.038 78.9521 56.1781C66.8637 56.5895 56.4616 66.9686 56.0503 79.0297C55.9132 83.4081 55.7989 87.7895 55.7075 92.1739C52.4748 95.3335 49.2466 98.4733 46.023 101.593C41.7224 105.775 39.3047 111.223 39.3047 117C39.3237 119.89 39.9289 122.745 41.0837 125.394C42.2385 128.043 43.9188 130.43 46.023 132.411C49.2466 135.528 52.4748 138.665 55.7075 141.821C55.7989 146.209 55.9132 150.595 56.0503 154.979C56.2331 160.852 58.7651 166.432 63.1114 170.788C67.3042 175.065 72.9682 177.585 78.9521 177.835C83.3457 177.972 87.7363 178.087 92.1238 178.178C95.3017 181.402 98.4445 184.622 101.552 187.84C103.528 189.96 105.919 191.651 108.577 192.807C111.235 193.963 114.102 194.56 117 194.56C119.898 194.56 122.765 193.963 125.423 192.807C128.081 191.651 130.472 189.96 132.448 187.84C135.574 184.625 138.72 181.403 141.885 178.173C146.273 178.085 150.66 177.972 155.048 177.835C167.132 177.424 177.538 167.036 177.95 154.984C178.087 150.605 178.201 146.225 178.292 141.844C181.525 138.688 184.753 135.542 187.977 132.406C190.079 130.425 191.758 128.038 192.912 125.391C194.067 122.743 194.674 119.888 194.695 117C194.695 111.214 192.278 105.766 187.972 101.589Z",
    fill: "url(#paint0_linear_1_5754)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.633 107.169C142.544 120.77 129.244 134.678 116.168 148.471C115.105 149.596 113.823 150.493 112.402 151.107C110.98 151.72 109.449 152.038 107.901 152.04H107.859C106.313 152.029 104.783 151.709 103.362 151.098C101.941 150.488 100.656 149.599 99.5827 148.484C92.5946 141.268 85.5564 134.056 78.5592 126.903C77.4947 125.834 76.6548 124.562 76.089 123.162C75.5233 121.763 75.243 120.265 75.2647 118.756C75.2864 117.247 75.6097 115.757 76.2155 114.375C76.8213 112.992 77.6974 111.745 78.7923 110.706C80.997 108.574 83.9551 107.398 87.0224 107.437C90.0896 107.475 93.0173 108.724 95.1677 110.912C99.345 115.196 103.531 119.493 107.727 123.805C118.111 112.927 128.54 101.991 138.805 91.2048C143.165 86.6344 150.437 86.543 155.112 90.9671C159.787 95.3912 160.025 102.608 155.633 107.169Z",
    fill: "url(#paint1_linear_1_5754)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5754",
    x1: 170.82,
    y1: 170.824,
    x2: 63.1754,
    y2: 63.1844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1977F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#65A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFD2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_5754",
    x1: 136.122,
    y1: 128.521,
    x2: 98.5315,
    y2: 90.9305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 234,
    height: 234,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessSignUpImage);
export default __webpack_public_path__ + "static/media/successSignUpImage.b283b62d.svg";
export { ForwardRef as ReactComponent };